import React from "react";
import { Link } from "react-router-dom";
import { CarouselSlot } from "../../../api/apiCalls";

interface BannerDetailsProps {
  carouselSlot: CarouselSlot | undefined;
}

function BannerDetails({ carouselSlot }: BannerDetailsProps) {
  return (
    <>
      <div className="col-sm-5">
        <div className="carousel-caption pt-5">
          <div className="sub-banner-area__text">
            <h4 className="font-weight-bold">{carouselSlot?.appName}</h4>
            <h5 className="sub-text mb-3 text-truncate">
              {carouselSlot?.summarizedDescription}
            </h5>
            <p className="sub-text m-0">{carouselSlot?.developerName}</p>
            {carouselSlot?.rating !== 0 && carouselSlot?.rating && (
              <p className="text-primary">
                <i className="fas fa-star">
                  {Math.round(carouselSlot?.rating * 10) / 10}
                </i>
              </p>
            )}
          </div>
        </div>
        <div className="carousel-action-btn">
          <Link
            className="btn btn-light"
            data-target="#carouselExampleCaptions2"
            data-slide-to="0"
            to={"/app-details/" + carouselSlot?.appId}
          >
            <i className="fas fa-arrow-right"></i>
          </Link>
        </div>
      </div>
    </>
  );
}

export default BannerDetails;
